module.exports = __webpack_public_path__ + "static/media/ci.c6fc9238.webp";